<template>
  <div class="account">
    <div class="account-bg"></div>
    <div class="account-logo"></div>
    <custom-input type="mobile" class="login-mobile" rules="mobile" placeholder="请输入手机号" @validate="handleValid" v-model="mobile"></custom-input>
    <custom-input type="password" class="login-password" rules="password" @validate="handleValid" v-model="password"></custom-input>
    <div class="login-links f-cb">
      <div class="login-save"><div class="login-save-check"></div>下次自动登录</div>
      <div class="login-forget" @click="forget_url">忘记密码？</div>
    </div>
    <div class="account-button" @click="login">账号登录</div>
    <div class="wechat_login" style="overflow: hidden;" v-if="isWeixin">
      <a :href="wx_url" style="display:block;">
        <img src="./wechat.png" alt="" style="width: 0.9rem;float:left;margin: 0.14rem 0.14rem 0 33%;"><span
        style="display: inline-block;float: left;">微信登录</span>
      </a>
    </div>
    <div class="login-register">还没有账号？<span @click="$router.push('/register')">去注册 ></span></div>
    <account-dialog :isOpen="isDialogShow" @close="isDialogShow=false" :textArr="error"></account-dialog>
  </div>
</template>

<script>
  import {dtCheck} from "../../util/dt-checkbox";
  import {dtDialog} from "../../util/dialog";

  export default {
    name: "login",
    data(){
      return {
        check:null,
        error:[],
        isDialogShow:false,
        mobile:"",
        password:"",
        isWeixin: true,
        wx_url : 'javascript:;'
      }
    },
    methods:{
      iswx() {
        var ua = navigator.userAgent.toLowerCase();
        var wechat = ua.indexOf('micromessenger') != -1;
        if (wechat) {
          this.isWeixin = true;
        } else {
          this.isWeixin = false;
        }
      },
      login(){
        //遍历所有子组件，验证其中的custom-input组件
        this.error=[];
        this.$children.forEach((value,index)=>{
          if(value.$options.name=="custom-input"){
            value.validate();
          }
        })
        if(this.error.length>0){
          this.isDialogShow=true;
        }
        else{
          this.$api.get('',{
            api:"/api/proxy/pass_login",
            user_pass:this.password,
            user_login:this.mobile,
            mode:1
          },res=>{
            if(res.status===1){
              this.$toast("登陆成功！");
              this.$store.commit("setLogin",1);
              window.setTimeout(()=>{
                // this.$router.push("/index");
                // this.$router.go(-1);
                if(document.referrer == '' || document.referrer.indexOf('register') != -1 || document.referrer.indexOf('recoverpwd') != -1||document.referrer.indexOf('http://passport2.chaoxing.com/')!=-1){
                  this.$router.push("/index")
                }else {
                  this.$router.go(-1);
                }
              },1000);
            }
          })
        }
      },
      handleValid(obj){
        if(!obj.result){
          this.error.push(obj.msg);
        }
      },
      forget_url(){
        window.location.href = 'http://passport2.chaoxing.com/pwd/getpwd?version=1&fid=-1&refer=' + encodeURIComponent(window.location.href);
      }
    },
    mounted(){
      //自定义复选框
      this.check=dtCheck({
        el:document.querySelector(".login-save-check"),
        className:"login-save-check-checked"
      });
      this.iswx();
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      this.$api.get('',{
        api:"/api/proxy/wechat_login",
        v_key:geturl_j2('v_key'),
      },res=>{
        if(res.status===1){
          this.wx_url = res.data.url
        }
      })

    }
  }
</script>

<style scoped>
  div.login-mobile{
    margin-top:1.067rem;
  }
  .login-links{
    margin:0.533rem 0.4rem 0 0.4rem;
    font-size:0.373rem;
    line-height:0.373rem;
  }
  .login-save{
    float:left;
    color:#0c539b;
  }
  .login-save-check{
    display: inline-block;
    width:0.293rem;
    height:0.293rem;
    margin-right:0.147rem;
    border:1px solid #999;
    border-radius: 2px;
  }
  .login-save-check-checked{
    background:url("../../asset/img/account/selected.png") center center no-repeat;
    background-size:0.253rem;
  }
  .login-forget{
    float:right;
    color:#999;
  }
  .login-register{
    margin-top:3.6rem;
    text-align: center;
    color:#999;
  }
  .login-register span{
    color:#0c539b;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue